function ThreeDPage() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center',
            padding: '2rem',
        }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎭</div>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>
                3D Model Generation
            </h2>
            <p style={{ color: 'var(--color-text-secondary, #666)', maxWidth: 380 }}>
                Turn your product photos into interactive 3D models. This feature is coming soon.
            </p>
            <span style={{
                marginTop: '1.5rem',
                display: 'inline-block',
                padding: '0.35rem 1rem',
                borderRadius: '999px',
                background: 'var(--color-surface-secondary, #f3f4f6)',
                color: 'var(--color-text-secondary, #666)',
                fontSize: '0.8rem',
                fontWeight: 600,
                letterSpacing: '0.05em',
            }}>
                COMING SOON
            </span>
        </div>
    );
}

export default ThreeDPage;
